import * as React from 'react'

import Hex from '../../engine/hex'
import { objectValues } from '../../utils'
import transform from '../utils/transform'
import * as iso from './iso'
import Store from './store'
import TileOverlay, { OverlayState } from './tileOverlay'

interface IProps {
  store: Store,
}

interface IOverlayCell {
  pos: Hex
  state: OverlayState[]
}

export default class Overlays extends React.Component<IProps, {}> {
  computeOverlays() {
    const overlays: { [idx: string]: IOverlayCell } = {}

    const set = (cell: Hex, style: OverlayState) => {
      const idx = cell.toString()
      if (!overlays[idx]) {
        overlays[idx] = { pos: cell, state: [] }
      }
      if (overlays[idx].state.indexOf(style) === -1) {
        overlays[idx].state.push(style)
      }
    }

    const { hover, selection } = this.props.store.state
    if (selection) {
      set(selection.cell.pos, 'selected')

      const action = selection.unit && selection.unit.action
      const paths = selection.unit && selection.unit.paths
      const threats = selection.unit && selection.unit.threats
      const dangerPaths = selection.unit && selection.unit.dangerPaths
      let attackers = selection.unit && selection.unit.attackers
      if (hover && paths && selection.unit && selection.unit.attackersByPath) {
        const hoverId = hover.cell.pos.toString()
        if (paths[hoverId]) {
          attackers = selection.unit.attackersByPath[hoverId]
        }
      }

      if (action) {
        objectValues(action.targets).forEach(t => set(t, 'target'))
        if (action.selectedTarget) {
          set(action.selectedTarget, 'currentTarget')
        }
      } else {
        if (paths) {
          objectValues(paths).forEach(t => set(t, 'moveTarget'))
        }
        if (threats) {
          objectValues(threats).forEach(t => set(t, 'threat'))
        }
        if (dangerPaths) {
          objectValues(dangerPaths).forEach(t => set(t, 'dangerMove'))
        }
        if (attackers) {
          objectValues(attackers).forEach(t => set(t.pos, 'threatAttacker'))
        }
      }
    }
    if (hover) {
      set(hover.cell.pos, 'hover')

      const selectedUnit  = selection && selection.unit
      const selectedAction = selectedUnit && selectedUnit.action
      if (selectedAction) {
        objectValues(selectedAction.area || {}).forEach(
          t => set(t, 'areaOfEffect'),
        )
      }

      if (!selectedUnit && hover.unit) {
        objectValues(hover.unit.paths).forEach(t => set(t, 'moveTarget'))
        objectValues(hover.unit.threats || {}).forEach(t => set(t, 'threat'))
        objectValues(hover.unit.dangerPaths || {})
          .forEach(t => set(t, 'dangerMove'))
        objectValues(hover.unit.attackers || {})
          .forEach(t => set(t.pos, 'threatAttacker'))
      }
    }

    return objectValues(overlays)
  }

  render() {
    const overlays = this.computeOverlays()

    const overlaysCells = overlays.map(overlay => {
      const { x, y } = iso.projectHex(overlay.pos)

      return (
        <g
          transform={transform.translate(x, y).string()}
          key={overlay.pos.toString()}
        >
          <TileOverlay state={overlay.state} />
        </g >
      )
    })

    return <g>{overlaysCells}</g>
  }
}



// WEBPACK FOOTER //
// ./src/ui/stageView/overlays.tsx